'use strict'

var tagString = require('./tagString')
var parse = require('./parse')

module.exports = function tag (/* [literals], ...substitutions */) {
  return parse(tagString.apply(null, arguments))
}



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/ltx/lib/tag.js
// module id = 380
// module chunks = 2